import { render } from "./ButtonStop.vue?vue&type=template&id=12985a1d&scoped=true"
import script from "./ButtonStop.vue?vue&type=script&lang=js"
export * from "./ButtonStop.vue?vue&type=script&lang=js"

import "./ButtonStop.vue?vue&type=style&index=0&id=12985a1d&scoped=true&lang=css"

import exportComponent from "H:\\_LK\\workInProgress\\vue-pomodoro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12985a1d"]])

export default __exports__